var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 96,
    viewBox: "0 0 472 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471 38.5128L456.898 29.2134C430.049 11.5083 395.207 11.6028 368.455 29.4532L331.401 54.1767C308.646 69.3599 279.711 71.8633 254.686 60.814L214.121 42.9035C190.864 32.6346 164.111 34.0315 142.049 46.6665L84.4901 79.6322C68.2786 88.9169 49.3288 92.2352 30.927 89.0116L1 83.769",
    stroke: "#B31017",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.43 59.7736L213.822 41.6594C190.728 31.605 164.246 33.0145 142.349 45.4638L81.0541 80.3125C77.2354 82.4836 73.2442 84.3365 69.1213 85.8524L66 87L56 89L45.5 90L35.5 89L1.5 83.5747L6 96H471V36.3309L454.61 26.6967C428.807 11.5287 396.694 12.0337 371.38 28.0057L330.053 54.0815C307.655 68.214 279.713 70.3454 255.43 59.7736Z",
    fill: "url(#paint0_linear_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 236,
    y1: 44.3407,
    x2: 236,
    y2: 106.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31017",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#6B1820",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09070D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.e386ce2c0c01f4920e601ff80b88370b.svg";
export { ForwardRef as ReactComponent };